var $2db6648255dd48ea$exports = {};
$2db6648255dd48ea$exports = {
  "collapse": "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
  "expand": "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C"
};
export { $2db6648255dd48ea$exports as default };